import { render, staticRenderFns } from "./SelectScriptsModelos.vue?vue&type=template&id=01ff7fc1&"
import script from "./SelectScriptsModelos.vue?vue&type=script&lang=js&"
export * from "./SelectScriptsModelos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VSelect})
